<template>
  <div>
    <!-- PÁGINA DE LOGIN -->
    <div v-if="telaLogin" class="limiter">
      <div class="container-login100">
        <div class="wrap-login100">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-card class="login100-form" flat style="border-radius: 15px;">
                <span class="login100-form-title">
                  <img src="../../assets/logo_roxa.png" width="200px">
                </span>
                <v-card-text>
                  <v-layout row wrap justify-center>
                    <v-flex xs10 sm10 lg9>
                      <v-text-field
                        color="#7B1FA2"
                        label="Código de Acesso"
                        single-line
                        outlined
                        dense
                        v-model="codigoAcesso"
                        required
                        prepend-inner-icon="lock"
                        @keydown.enter="entrar"
                      />
                    </v-flex>
                    <a class="blind-button" @click="recuperaCodigo()">
                      <span>Recuperar código de acesso</span>
                    </a>
                    <br>
                    <v-flex xs10 sm10 lg9>
                      <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="entrar">Acessar</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-row>
            <br>
            <div class="login100-form-title">
              <a href="https://www.intelitetecnologia.com.br/" target="_blank">
                <img src="../../assets/LogoBrancoHorizontal.png" width="130px">
              </a>
            </div>
            <br>
          </v-container>
        </div>
      </div>
    </div>
    <!-- FIM DA PÁGINA DE LOGIN -->

    <!-- PÁGINA DO VÍDEO -->
    <v-container v-if="usuarioLogado" fluid grid-list-md>
      <v-row row wrap style="margin: 0 auto">
        <v-flex xs12 sm12 md12 lg12>
          <p style="text-align: center">{{inscricao.nome}}, bem vindo ao portal de vídeos do AIPass!</p>
        </v-flex>
        <v-flex xs6 sm12 md12 lg2 style="margin: 0 auto">
          <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="sair">Sair</v-btn>
        </v-flex>
      </v-row>
      <br>
      <!-- <iframe :src="`${urlLive}`" width="100%" height="680px" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>
      <br> -->
      <v-flex xs12 sm12 md12 lg12 style="margin: 0 auto">
        <h1>Gravações</h1>
      </v-flex>
      <v-layout row wrap justify-center>
      <v-flex xs12 sm4 md6 lg6 style="margin: 10px auto">
        <p style="text-align: center">Perfumadas Florescer 2021: Dia 1</p>
        <video width="100%" :src="gravacaoUm" controls controlsList="nodownload" oncontextmenu="return false;">Seu navegador não suporta o elemento <code>video</code>.</video>
      </v-flex>
      <v-flex xs12 sm4 md6 lg6 style="margin: 10px auto">
        <p style="text-align: center">Perfumadas Florescer 2021: Dia 2</p>
        <video width="100%" :src="gravacaoDois" controls controlsList="nodownload" oncontextmenu="return false;">Seu navegador não suporta o elemento <code>video</code>.</video>
      </v-flex>
       <v-flex xs12 sm4 md6 lg6 style="margin: 10px auto">
        <p style="text-align: center">Perfumadas Florescer 2021: Dia 3 (Tarde)</p>
        <video width="100%" :src="gravacaoTres" controls controlsList="nodownload" oncontextmenu="return false;">Seu navegador não suporta o elemento <code>video</code>.</video>
      </v-flex>
       <v-flex xs12 sm4 md6 lg6 style="margin: 10px auto">
        <p style="text-align: center">Perfumadas Florescer 2021: Dia 3 (Noite)</p>
        <video width="100%" :src="gravacaoQuatro" controls controlsList="nodownload" oncontextmenu="return false;">Seu navegador não suporta o elemento <code>video</code>.</video>
      </v-flex>
      </v-layout>
    </v-container>
    <v-footer color="#4A148C" width="auto" style="justify-content: center;">
          <p class="textofooter">COPYRIGHT © 2020 - AIPASS INTELITE</p>
          <v-spacer></v-spacer>
          <v-btn icon dark href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
          <img src="../../assets/instagram.png">
          </v-btn>
    </v-footer>
    <!-- FIM DA PÁGINA DO VÍDEO -->

    <!-- pagina consulta -->
    <div v-if="telaRecuperaCodigo" class="limiter">
      <div class="container-login100">
        <div>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
                <span class="login100-form-title">
                  <img src="../../assets/logo_roxa.png" width="200px">
                </span>
                <v-card-text style="padding: 0px">
                  <v-container fluid grid-list-md>
                    <v-layout row wrap justify-left>
                      <v-flex xs12 sm12 lg12>
                        <p style="margin-bottom: 0px;">Informe seu CPF para recuperar o código de acesso:</p>
                      </v-flex>
                      <v-flex xs12 sm12 lg12>
                        <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions style="padding: 0px">
                  <v-container fluid grid-list-md>
                    <v-layout row wrap justify-center>
                      <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="recuperarAcesso">Recuperar Código</v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 lg8>
                        <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="retornaLogin">Retornar ao Login</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <br>
            <div class="login100-form-title">
              <a href="https://www.intelitetecnologia.com.br/" target="_blank">
                <img src="../../assets/LogoBrancoHorizontal.png" width="130px">
              </a>
            </div>
          <br>
        </div>
      </div>
    </div>
    <!-- fim pagina consulta -->
    <Loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#784e9b"
      :is-full-page="fullPage"
    ></Loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { mapState } from 'vuex'
    export default {
      components: {Snackbar, Loading},
      data () {
        return {
          codigoAcesso: '',
          telaLogin: true,
          inscricao: [],
          telaRecuperaCodigo: false,
          mask: '###.###.###-##',
          cpf: '',
          idInscricao: '',
          emailInscricao: '',
          usuarioLogado: false,
          isLoading: false,
          fullPage: false,
          verificaCodAcesso: 0,
          urlLive: '',
          gravacaoUm: 'https://video.wixstatic.com/video/0e7ab6_1f50bb78d9d940c9a3834b0ee1a8d5d7/720p/mp4/file.mp4',
          gravacaoDois: 'https://video.wixstatic.com/video/0e7ab6_6160f0c2a92648a08d94ddea11b1438b/720p/mp4/file.mp4',
          gravacaoTres: 'https://video.wixstatic.com/video/0e7ab6_45d73674bb8d4b9f91d6e6a43cea3107/480p/mp4/file.mp4',
          gravacaoQuatro: 'https://video.wixstatic.com/video/0e7ab6_f4b2fd8e597d423caa1445965253cd64/720p/mp4/file.mp4'
        }
      },

      computed: mapState({
        // usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,  
        numberOfPages () {
          return Math.ceil(this.items.length / this.itemsPerPage)
        },
        filteredKeys () {
          return this.keys.filter(key => key !== `Name`)
        },   
      }),

      async mounted () {
        if (localStorage.getItem("cod") != null && localStorage.getItem("cod") != '') {
          this.isLoading = true
          await axios.get(`${baseApiUrl}inscricoes/count?where={"codigoAcesso":"${localStorage.getItem("cod")}"}`).then(res => {
            if (res.data.count == 1) {
              axios.post(`${baseApiUrl}inscricoes/inscricaoCodigoAcesso`, {"codigoAcesso": localStorage.getItem("cod")}).then(res => {
                this.inscricao = res.data
                this.carregaUrlLive()
                this.telaLogin = false
                this.usuarioLogado = true
                this.isLoading = false
                this.verificaCodAcesso = setInterval(function() {
                  axios.get(`${baseApiUrl}inscricoes/count?where={"codigoAcesso":"${localStorage.getItem("cod")}"}`).then(res => {
                    if (res.data.count != 1) {
                      clearInterval(this.verificaCodAcesso)
                      var vm = this;
                      vm.$refs.chamaSnackbar.snack("#F9A825","Inscrição não localizada. Verifique o código de acesso ou clique em 'Recuperar código de acesso'","ATENÇÃO");
                      this.usuarioLogado = false
                      this.telaLogin = true
                      this.inscricao = []
                    }
                  })
                }, 180000);
              })
            } else {
              this.telaLogin = true
              this.usuarioLogado = false
            }
          })
        }
      },

      methods: {
        async entrar() {
          if (this.codigoAcesso == '') {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Informe o código de acesso","ATENÇÃO");
          } else {
            this.isLoading = true
            try {
              await axios.post(`${baseApiUrl}inscricoes/inscricaoCodigoAcesso`, {"codigoAcesso": this.codigoAcesso}).then(res => {
              if (res.data) {
                if (res.data.logado) {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Já existe um dispositivo conectado com esse código de acesso. Faça logout no outro dispositivo antes de acessar ou, se preferir, recupere agora seu acesso.","ATENÇÃO");
                } else {
                  localStorage.setItem("cod", this.codigoAcesso)
                  this.inscricao = res.data
                  this.inscricao.logado = true
                  this.telaLogin = false
                  this.usuarioLogado = true
                  this.atualizaStatus()
                  this.isLoading = false
                  this.verificaCodAcesso = setInterval(function() {
                    axios.get(`${baseApiUrl}inscricoes/count?where={"codigoAcesso":"${res.data.codigoAcesso}"}`).then(res => {
                      if (res.data.count != 1) {
                        clearInterval(this.verificaCodAcesso)
                        vm = this;
                        vm.$refs.chamaSnackbar.snack("#F9A825","Inscrição não localizada. Verifique o código de acesso ou clique em 'Recuperar código de acesso'","ATENÇÃO");
                        this.usuarioLogado = false
                        this.telaLogin = true
                        this.inscricao = []
                      }
                    })
                  }, 180000);

                  //CARREGA URL DA LIVE
                  this.carregaUrlLive()

                }
              } else {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825","Inscrição não localizada. Verifique o código de acesso ou clique em 'Recuperar código de acesso'","ATENÇÃO");
              }
            })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao encontrar inscrição","DESCULPE");
            }
          }
        },

        async carregaUrlLive(){
            //CARREGA URL DA LIVE
            try {
              let res = await axios.get(`${baseApiUrl}Eventos?filter[where][id]=61701f2024322036f3c34125&access_token=${sessionStorage.getItem('accToken')}`)
                this.urlLive = res.data[0].urlLive
            }
            catch {
              //
            }
        },

        async sair() {
          this.isLoading = true
          try {
            this.inscricao.logado = false
            await this.atualizaStatus()
            this.usuarioLogado = false
            this.telaLogin = true
            this.inscricao = []
            this.isLoading = false
            clearInterval(this.verificaCodAcesso)
            localStorage.removeItem("cod")
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao efetuar logout, tente novamente","DESCULPE");
          }
        },

        async atualizaStatus() {
          try {
            await axios.post(`${baseApiUrl}inscricoes/replaceOrCreate`, this.inscricao)
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao atualizar inscrição","DESCULPE");
          }
        },

        recuperaCodigo () {
          this.telaLogin = false
          this.telaRecuperaCodigo = true
        },

        retornaLogin() {
          this.telaLogin = true
          this.telaRecuperaCodigo = false
        },

        async recuperarAcesso() {
          if (this.cpf == '') {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Preencha o CPF para continuar","DESCULPE");
          } else {
            this.isLoading = true
            try {
              let res = await axios.post(`${baseApiUrl}inscricoes/inscricaoCpf`, {"cpf": this.cpf})
              if (res.data) {
                this.idInscricao = res.data.id
                this.emailInscricao = res.data.email
                this.enviaEmailRecuperacao()
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema encontrado ao recuperar código de inscrição","DESCULPE");
            }
          }          
        },

        async enviaEmailRecuperacao() {
          try {
            await axios.post(`${baseApiUrl}Inscricoes/EmailRecuperaAcesso`, {"inscricaoId": this.idInscricao} ).then(res => {
              if (res.data) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#008000", "Foi enviado um e-mail para " + this.emailInscricao + " com seu novo código de acesso.", "SUCESSO")
              }
            })
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
          }
        },
      },
    }
</script>

<style>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login100 {
    width: 100%;  
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #4A148C, #8E24AA);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;  
  }

  .wrap-login100 {
    width: 400px;
    overflow: hidden;
    background: transparent;
  }

  .login100-form {
    max-width: 90%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login100-form-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
  /* Remove botão de download de vídeos */
  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px); /* Adjust as needed */
  }
</style>